import React from 'react';

const SmsSettings = ({
  smsSettings,
  setSmsSettings,
  handleSaveSmsSettings,
  loading
}) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold mb-4">SMS Ayarları</h3>
      
      {/* Bilgi Notu */}
      <div className="bg-blue-50 border border-blue-200 text-blue-700 px-4 py-3 rounded-lg mb-4">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm">
              <strong>Not:</strong> Eğer bu alanları boş bırakırsanız, sistem otomatik olarak .env dosyasındaki ayarları kullanacaktır.
              <br />Buraya girdiğiniz değerler .env ayarlarını geçersiz kılar.
              <br /><strong>.env Ayarları:</strong> NETGSM_USERNAME, NETGSM_PASSWORD, NETGSM_HEADER, CONTACT_PHONE
            </p>
          </div>
        </div>
      </div>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          SMS Sağlayıcı
        </label>
        <select
          value={smsSettings.provider}
          onChange={(e) => setSmsSettings({ ...smsSettings, provider: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        >
          <option value="netgsm">NetGSM</option>
          <option value="iletimerkezi">İleti Merkezi</option>
        </select>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Kullanıcı Adı
        </label>
        <input
          type="text"
          value={smsSettings.username}
          onChange={(e) => setSmsSettings({ ...smsSettings, username: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Şifre
        </label>
        <input
          type="password"
          value={smsSettings.password}
          onChange={(e) => setSmsSettings({ ...smsSettings, password: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          SMS Başlığı (Max 11 karakter)
        </label>
        <input
          type="text"
          value={smsSettings.header}
          onChange={(e) => setSmsSettings({ ...smsSettings, header: e.target.value })}
          maxLength={11}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          İletişim Telefonu
        </label>
        <input
          type="text"
          value={smsSettings.contact_phone}
          onChange={(e) => setSmsSettings({ ...smsSettings, contact_phone: e.target.value })}
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          placeholder="05xx xxx xx xx"
        />
      </div>

      <button
        onClick={handleSaveSmsSettings}
        disabled={loading}
        className="w-full bg-purple-600 text-white py-3 rounded-lg font-medium hover:bg-purple-700 transition-colors disabled:bg-gray-400"
      >
        {loading ? 'Kaydediliyor...' : 'Ayarları Kaydet'}
      </button>
    </div>
  );
};

export default SmsSettings;